<template>
  <div v-click-outside='outsideClick' class='ui-calendar'>
    <div class='input-area' @click='isPickDate = !isPickDate'>
      <!--            <input type="text" readonly placeholder="날짜 입력" :value="inputValue" :disabled="disabled" />-->
      <input :disabled='disabled' :value='showValue' placeholder='날짜 입력' readonly type='text'/>
    </div>
    <div v-show='!disabled && isPickDate' class='calendar-box'>
      <b-calendar ref='bootstrapCalendar'
                  hide-header
                  v-model='inputValue'
                  :date-disabled-fn='dateDisabled'
                  :date-info-fn='dateClass'
                  :min=minDate
                  @context='changeDate'
                  @input='inputChange(inputValue)'
                  @selected='selectDate'
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import api from '../assets/js/api';

export default {
  name: 'SingleCalendar',
  props: {
    selectData: Array,
    date: String,
    startDate: String,
    endDate: String,
    minDate: Date|String,
    id: String,
    showDateFormat: {
      default: 'YYYY-MM-DD',
      type: String,
    },
    showDateLocale: {
      default: 'ko',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    disabledBeforeToday: {
      default: false,
      type: Boolean,
    },
    disabledBeforeDate: {
      default: '',
      type: String,
    },
    disabledAfterDate: {
      default: '',
      type: String,
    },
    disabledDateList: {
      default() {
        return [];
      },
      type: Array,
    },
  },
  watch: {
    date(newVal) {
      this.inputValue = newVal;
    },
    startDate(newVal) {
      this.inputValue = newVal;
      // this.showValue = newVal;
    },
    endDate(newVal) {
      this.inputValue = newVal;
      // this.showValue = newVal;
    },
  },
  data() {
    return {
      inputValue: this.date,
      isPickDate: false,
      today: moment().format('YYYY-MM-DD'),
      showValue: '',
      holidays: [],
    };
  },
  mounted() {
    if (this.startDate) {
      this.inputValue = this.startDate;
    }
    if (this.endDate) {
      this.inputValue = this.endDate;
    }
    if (this.date) {
      this.showValue = this.date;
      this.date = this.date;
    }
  },
  created() {

  },
  methods: {
    setCalendarSelectedDate(selectedDate) {
      this.$refs.bootstrapCalendar.selectedYMD = selectedDate;
      this.$refs.bootstrapCalendar.activeYMD = selectedDate;
    },
    inputChange(date) {
      if (date !== '') {
        this.showValue = moment(date).locale(this.showDateLocale).format(this.showDateFormat);
      } else {
        this.showValue = '';
      }
      this.isPickDate = false;
    },
    outsideClick() {
      this.isPickDate = false;
    },
    resetDate() {
      this.inputDate = '';
    },
    dateDisabled(ymd, date) {
      if (this.disabledBeforeToday && moment(ymd).isBefore(this.today)) {
        return true;
      }

      if (this.disabledBeforeDate !== '' && moment(ymd).isBefore(this.disabledBeforeDate)) {
        return true;
      }

      if (this.disabledAfterDate !== '' && moment(ymd).isAfter(this.disabledAfterDate)) {
        return true;
      }

      if (this.disabledDateList && this.disabledDateList.length > 0) {
        for (const disabledDate of this.disabledDateList) {
          const {startDate, endDate} = disabledDate;
          if (!moment(ymd).isAfter(endDate) && !moment(ymd).isBefore(startDate)) {
            return true;
          }
        }
      }
      return false;
    },
    initShowValue() {
      this.shwoValue = '';
    },
    dateClass(ymd) {
      for (const d of this.holidays) {
        if (ymd === d) {
          return 'holiday-round';
        }
      }
      return false;
    },
    // 이전 달, 다음 달로 넘길 때, 이벤트 함수..
    changeDate(context) {
      // 선택된 달의 휴일을 구하기 위한 api파라메터 작성
      const ym = `${context.activeDate.getFullYear()}-${(context.activeDate.getMonth() + 1).toString().padStart(2, '0')}`;
      const centerId = parseInt(this.$store.getters['auth/cId']);
      // 공통 컴포넌트이기 때문에 부모 컴포넌트에서 id를 주지 않을 경우.. 에러방지..

      // 휴일 구하기 함수..
      this.getMonthHolidays(centerId, ym);
    },
    async selectDate(ymd, date) {
        this.$emit('update', ymd);
        this.$emit('change', ymd, this.id);
    },
    // 휴일 구하기 함수..
    async getMonthHolidays(centerid, ym) {
      if (centerid !== 0) {
        api.get(`/admin/api/center/${centerid}/holiday/${ym}`)
            .then((res) => {
              // 휴일을 배열로 넣기..
              this.holidays = [];
              for (const d of res.data) {
                this.holidays.push(d.holidayDate);
              }
            })
            .catch((res) => {

            });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.ui-calendar {
  position: relative;
  display: inline-block;
  width: 200px;
  height: 32px;
  vertical-align: top;

  .input-area {
    position: relative;
    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 43px;
      height: 32px;
      background: url('/img/icons/ic_calendar.png') no-repeat 0 0;
    }

    input {
      width: 100%;
      height: 32px;
      padding-left: 14px;
      border: 1px solid #ced4da;
      border-radius: 5px;
      font-size: 14px;
      color: #545454;
      cursor: pointer;
      vertical-align: top;
    }
  }

  .calendar-box {
    position: absolute;
    left: 0;
    top: 33px;
    background: #fff;

    z-index: 800;

    .b-calendar-header {
      display: none;
    }
  }
}
</style>
